import React, { ReactNode, useEffect, useRef } from "react";
import ModelFramer from "../framerMotion/ModelFramer";
import Image from "../images/Image";
import useTranslation from "../CustomHooks/useTranslation";

type MainModelProps = {
  children?: ReactNode; // Optional children prop
  isClose?: boolean;
  loginFlow?: boolean;
  handleClose?: () => void;
  modelWidth?: string;
  disableOutsideClick?: boolean;
  modelHeight?: string;
  padding?: string;
};

export default function MainModel({
  modelWidth,
  children,
  isClose,
  loginFlow,
  handleClose,
  disableOutsideClick = false,
  modelHeight,
  padding
}: MainModelProps) {
  const { notEnglish } = useTranslation({});
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Only close the modal if disableOutsideClick is false
      if (
        !disableOutsideClick &&
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        handleClose && handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClose, disableOutsideClick]);

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Check if the click is on the backdrop and not inside the modal
    // Only close if disableOutsideClick is false
    if (!disableOutsideClick && event.target === event.currentTarget && handleClose) {
      handleClose();
    }
  };

  return (
    <div
      dir={`${notEnglish ? "rtl" : "ltr"}`}
      className={`fixed flex items-center justify-center ${loginFlow ? '' : 'bg-black bg-opacity-60 inset-0 z-50'}`}
      onClick={handleBackdropClick} // Handle click outside the modal
      role="dialog"
    >
      <ModelFramer
        ref={modalRef}
        className={`bg-white ${modelWidth ? modelWidth : 'w-[570px]'} ${modelHeight ? modelHeight : ''} rounded-lg ${padding || "p-6"} shadow-xl relative`}
      >
        {isClose && (
          <div className="flex justify-end">
            <Image
              src="close"
              onClick={() => handleClose && handleClose()}
              className="cursor-pointer"
            />
          </div>
        )}
        {children}
      </ModelFramer>
    </div>
  );
}